import {
  REPORT_PRIMARY_ACCENT,
  REPORT_PRIMARY_ACCENT_BORDER_SOFT,
  REPORT_PRIMARY_ACCENT_HOVER,
  REPORT_PRIMARY_ACCENT_SOFT_BG,
  REPORT_PRIMARY_BUTTON_SHADOW,
  REPORT_PRIMARY_BUTTON_SHADOW_HOVER,
  REPORT_PRIMARY_BUTTON_TEXT,
  REPORT_RANGE_SEPARATOR_BG
} from '../../../constants/reportUiTokens'

export const REPORT_DATE_RANGE_ROW_PICKER_WIDTH = 200

export const getEffectivenessReportDateTextFieldSx = ({ isColumn, rowPickerWidth }) => ({
  ...(!isColumn
    ? {
        width: rowPickerWidth,
        '& .MuiFormControl-root': {
          width: rowPickerWidth
        }
      }
    : {}),
  '& .MuiOutlinedInput-root': {
    borderRadius: 1,
    '& fieldset': {
      borderColor: REPORT_PRIMARY_ACCENT_BORDER_SOFT
    },
    '&:hover fieldset': {
      borderColor: REPORT_PRIMARY_ACCENT
    },
    '&.Mui-focused fieldset': {
      borderColor: REPORT_PRIMARY_ACCENT
    },
    '&.Mui-focused:hover fieldset': {
      borderColor: REPORT_PRIMARY_ACCENT
    }
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderWidth: 1
  }
})

export const getEffectivenessReportDatePickerSlotPropsBase = ({ isColumn, textFieldSx }) => ({
  openPickerButton: {
    sx: {
      color: REPORT_PRIMARY_ACCENT,
      '&:hover': { backgroundColor: REPORT_PRIMARY_ACCENT_SOFT_BG }
    }
  },
  openPickerIcon: {
    sx: { color: REPORT_PRIMARY_ACCENT }
  },
  textField: {
    size: 'small',
    fullWidth: isColumn,
    sx: textFieldSx
  }
})

export const getEffectivenessReportDateStackSx = (isColumn) =>
  isColumn
    ? { width: '100%' }
    : {
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: { xs: 1.5, sm: 2 },
        rowGap: 1.5
      }

export const REPORT_DATE_RANGE_LABEL_SX = {
  fontWeight: 500
}

export const REPORT_DATE_RANGE_SEPARATOR_SX = {
  width: 36,
  height: 4,
  flexShrink: 0,
  alignSelf: 'center',
  borderRadius: 0.5,
  bgcolor: REPORT_RANGE_SEPARATOR_BG
}

export const getEffectivenessReportDateActionWrapSx = (isColumn) =>
  isColumn ? { width: '100%' } : { display: 'flex', alignItems: 'center', ml: { xs: 0, sm: 0.5 } }

export const getEffectivenessReportDateButtonSx = (isColumn) => ({
  py: isColumn ? 1.25 : 0.75,
  px: isColumn ? 2 : 2.5,
  whiteSpace: 'nowrap',
  bgcolor: REPORT_PRIMARY_ACCENT,
  color: REPORT_PRIMARY_BUTTON_TEXT,
  fontWeight: 400,
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
  boxShadow: REPORT_PRIMARY_BUTTON_SHADOW,
  '&:hover': {
    bgcolor: REPORT_PRIMARY_ACCENT_HOVER,
    boxShadow: REPORT_PRIMARY_BUTTON_SHADOW_HOVER
  }
})
